const mapping: Record<string, string> = {
  id: 't=>t.Id',
  name: 't=>t.Name',
}

export const mapSortTicketImportTemplateParam = (key: string) => mapping[key]
